/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Leveling_Perm_Manage_Guild_HintInputs */



/**
* | output |
* | --- |
* | "Allow members to change this server’s name, switch regions, view all invites, add apps to this server and create and update AutoMod rules." |
*
* @param {Leveling_Perm_Manage_Guild_HintInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const leveling_perm_manage_guild_hint = /** @type {((inputs?: Leveling_Perm_Manage_Guild_HintInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Leveling_Perm_Manage_Guild_HintInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("Позволяет участникам менять название сервера и его регион, видеть все приглашения, добавлять на сервер приложения, а также создавать и изменять правила AutoMod.")
	return /** @type {LocalizedString} */ ("Allow members to change this server’s name, switch regions, view all invites, add apps to this server and create and update AutoMod rules.")
});